import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  buildShowEntityApp,
  buildShowEntityAppContentTab,
} from '../../../navigation/appRoutes';
import LinkButton from './LinkButton';

const V2V1Link = ({
  app,
  entityPrimaryFieldValue,
  trackOnClick,
  tooltip,
}: {
  entity: EntityDetails.Entity;
  app: EntityDetails.App;
  entityPrimaryFieldValue: string;
  trackOnClick: () => void;
  tooltip: string;
}) => {
  const to = useMemo(() => {
    if (app.tabs.length > 0) {
      return buildShowEntityAppContentTab({
        entityApp: app,
        value: entityPrimaryFieldValue,
        tabId: app.tabs[0].typeId,
        tabType: app.tabs[0].type,
      });
    }

    return buildShowEntityApp({
      entityApp: app,
      value: entityPrimaryFieldValue,
    });
  }, [app, entityPrimaryFieldValue]);

  return (
    <RouterLink to={to} target="_blank" onClick={trackOnClick}>
      <LinkButton tooltip={tooltip} />
    </RouterLink>
  );
};

export default V2V1Link;
